
import React, { Component}  from 'react';
import { DetailProvider, DetailContext } from 'core/DetailProvider';
import { FormContext, FormProvider } from 'core/FormProvider';
import Layout from 'components/Dashboard/Layout';
import FormDialogWrapper from "./FormConfigmDialog";


export default class OrderEdit extends Component {

  static defaultProps = {
    apiUrl: 'order',
    basePath: '/order',
  };

  onLoaded = (item) => {
    document.title = `Редактирование перевозки`;
  };

  getReturnPath = () => {
    const { location, basePath } = this.props;
    if (location && location.state && location.state.from) {
      return location.state.from;
    }
    return basePath;
  };

  handlePostSave = (context, item) => {
    this.props.history.push(this.getReturnPath());
  };

  render() {
    const { match, apiUrl, basePath } = this.props;
    return (
      <DetailProvider
        url={`${apiUrl}/${match.params.id}`}
        onLoaded={(item) => this.onLoaded(item)}
      >
        <DetailContext.Consumer>
          {detailContext => {
            let { item } = detailContext;
            return (
              <FormProvider
                url={`${apiUrl}/${match.params.id}`}
                postSaveMessage={'Перевозка обновлена'}
                item={item}
              >
                <FormContext.Consumer>
                {formContext => {
                  return (
                    <Layout>
                      <Layout.Header
                        title={'Редактирование перевозки'}
                        backUrl={this.getReturnPath()}
                      />

                      <Layout.ContentSimple>
                        <FormDialogWrapper
                          formContext={formContext}
                          onPostSave={this.handlePostSave}
                          buttonLabel={'Обновить перевозку'}
                        />
                      </Layout.ContentSimple>
                    </Layout>
                  )
                }}
                </FormContext.Consumer>
              </FormProvider>
            )
          }}
        </DetailContext.Consumer>
      </DetailProvider>
    )
  }
}
